import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select'
import icons from '../assets/icons'

NewSelect.propTypes = {
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
        name: PropTypes.string
    })),
    name: PropTypes.string,
    important: PropTypes.bool,
    reff: PropTypes.any,
    onChange: PropTypes.func
};
const styles = {
    control: () => ({
        width: '100%',
        height: '50px',
        display: 'flex',
        position: 'relative',
        border: '2px solid #BCE0FD',
        borderRadius: '5px',
        background: 'aliceblue'
    }),
    indicatorSeparator: () => ({
        width: 0
    }),

}

function NewSelect(props) {

    const DropdownIndicator = (props) => {
        return (
          <components.DropdownIndicator {...props}>
              <img width={'15px'} height={'15px'} style={{marginTop: '2px'}} src={icons.arrowDown} alt='drop' />
          </components.DropdownIndicator>
        )
    }

    const IndicatorsContainer = props => {
        return <components.IndicatorsContainer {...props}>
            <div style={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                paddingRight: '9px'
            }}>
                {props.children}
            </div>
        </components.IndicatorsContainer>
    }

    return (
        <div key={props.name + props.label} className="form__option">
            <label htmlFor={props.name}>{props.label} {props.important &&
            <span style={{color: 'red'}}>*</span>} </label>
            <input ref={props.reff} name={props.name} style={{display: 'none'}}/>
            <Select onChange={props.onChange} isSearchable={false} placeholder={props.placeholder} id={props.id}
                    components={{ DropdownIndicator, IndicatorsContainer }}
                    options={props.options}
                    value={props.value}
                    styles={styles}/>
        </div>
    );
}

export default NewSelect;
